import { forwardRef, useMemo } from 'react';

import { Box } from '@mui/material';
import { GridColumnMenuHideItem } from '@mui/x-data-grid';
import { GridColumnMenu, GridColumnMenuProps } from '@mui/x-data-grid-premium';

import GeneratikTableColumnMenuGroupItem from './GeneratikTableColumnMenuGroupItem';
import GeneratikTableColumnMenuPinningItem from './GeneratikTableColumnMenuPinningItem';
import GeneratikTableColumnMenuSortItem from './GeneratikTableColumnMenuSortItem';
import { useGeneratikTableContext } from './GeneratikTableContext';
import { getContextMenuItemSx, getContextMenuPaperSx } from './contextMenuDesign';

const GeneratikTableColumnMenu = forwardRef<HTMLUListElement, GridColumnMenuProps>(
  function GeneratikTableColumnMenu(props, ref) {
    const { groupOptions, disableGroupButton, onGroupChange } = useGeneratikTableContext();
    const { colDef } = props;

    const isGroupable =
      !disableGroupButton &&
      !!onGroupChange &&
      (groupOptions?.some((opt) => opt.field === colDef.field) ?? false);

    const slots = useMemo(
      () => ({
        columnMenuFilterItem: null,
        columnMenuColumnsItem: null,
        columnMenuAggregationItem: null,
        columnMenuGroupingItem: isGroupable ? GeneratikTableColumnMenuGroupItem : null,
        columnMenuHideItem: GridColumnMenuHideItem,
        columnMenuSortItem: GeneratikTableColumnMenuSortItem,
        columnMenuPinningItem: GeneratikTableColumnMenuPinningItem,
      }),
      [isGroupable],
    );

    const slotProps = useMemo(
      () => ({
        columnMenuHideItem: { displayOrder: 31 },
      }),
      [],
    );

    return (
      <Box
        sx={(theme) => ({
          ...getContextMenuPaperSx(theme),
          '& .MuiMenuItem-root': getContextMenuItemSx(theme),
        })}
      >
        <GridColumnMenu {...props} ref={ref} slots={slots} slotProps={slotProps} />
      </Box>
    );
  },
);

export default GeneratikTableColumnMenu;
